import { useIntl } from "react-intl";
import { Attachment } from "common/api/decimal/methods/course";
import { Dialog } from "common/core-ui/Dialog";
import Attachments from "./Attachments";

export default function InstructionAttachmentsDialog({
  attachments,
  onRequestClose,
}: {
  attachments: Attachment[];
  onRequestClose: () => void;
}) {
  const intl = useIntl();
  return (
    <Dialog
      title={intl.formatMessage({ defaultMessage: "Attachments" })}
      onRequestClose={onRequestClose}
      primaryButton={{
        onClick: onRequestClose,
        label: intl.formatMessage({ defaultMessage: "Done" }),
      }}
    >
      <Attachments attachments={attachments} />
    </Dialog>
  );
}
